import { Skeleton } from '@mui/material';

export const CustomSkeleton = () => (
  <>
    {[...Array(8)].map((_, index) => (
      <Skeleton key={index} variant='rect' sx={{ width: '100%', margin: '15px', height: 60 }} />
    ))}
  </>
);
